import { Component, type ErrorInfo, type ReactNode } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from './Button';
import { Card } from './Card';

type State = { error: Error | null };

export class ErrorBoundary extends Component<{ children: ReactNode; fallback?: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('Wiqaya UI error:', error, info);
  }

  reset = () => {
    this.setState({ error: null });
  };

  render() {
    if (this.state.error) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div className="full-center">
          <Card>
            <div className="empty-state">
              <div className="empty-icon" aria-hidden>
                <AlertTriangle size={26} />
              </div>
              <h3>Something went wrong</h3>
              <p>{this.state.error.message || 'An unexpected error occurred. Please refresh the page.'}</p>
              <div className="empty-actions">
                <Button variant="primary" leadingIcon={<RefreshCw size={16} />} onClick={() => window.location.reload()}>
                  Reload
                </Button>
                <Button variant="ghost" onClick={this.reset}>
                  Try again
                </Button>
              </div>
            </div>
          </Card>
        </div>
      );
    }
    return this.props.children;
  }
}
